import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../AuthContext';
import NotificationContext from '../NotificationContext';

const Login = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [loading, setLoading] = useState(false);
    const { login } = useContext(AuthContext);
    const { showNotification } = useContext(NotificationContext);
    const navigate = useNavigate();

    const { email, password } = formData;

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = async e => {
        e.preventDefault();
        setLoading(true);
        try {
            const success = await login(email, password);
            if (success) {
                showNotification('Login Successful!', 'success');
                navigate('/');
            }
        } catch (err) {
            console.error(err);
            showNotification('An error occurred during login.', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-image-container">
                {/* Replace with your image */}
                <img src="login-illustration.svg" alt="Login Illustration" />
            </div>
            <div className="auth-form-container">
                <div className="form-container">
                    <h1>Login</h1>
                    <form onSubmit={onSubmit}>
                        <div className="form-group">
                            <label className="form-label">Email Address</label>
                            <input
                                type="email"
                                placeholder="Email Address"
                                name="email"
                                value={email}
                                onChange={onChange}
                                className="form-control"
                                required
                                disabled={loading}
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Password</label>
                            <input
                                type="password"
                                placeholder="Password"
                                name="password"
                                value={password}
                                onChange={onChange}
                                className="form-control"
                                required
                                disabled={loading}
                            />
                        </div>
                        <input 
                            type="submit" 
                            value={loading ? 'Logging in...' : 'Login'} 
                            className="btn" 
                            disabled={loading} 
                        />
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;